import * as React from "react";
import type { SVGProps } from "react";
const SvgOverdue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#D6DBE7"
      fillRule="evenodd"
      d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1"
      clipRule="evenodd"
    />
    <path
      stroke="#041E78"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 5.395v2.337a.5.5 0 0 0 .223.416l1.73 1.154"
    />
  </svg>
);
export default SvgOverdue;
